const setAuthentication = (state, payload) => {
  state.authentication = payload;
};

const setDecodedAuthentication = (state, payload) => {
  state.decodedAuthentication = payload;
};

const setUserRole = (state, payload) => {
  state.userRole = payload;
};

const setOrganisations = (state, payload) => {
  state.organisations = payload;
};

const setSelectedOrganisation = (state, payload) => {
  state.selectedOrganisation = payload;
};

const setLogSources = (state, payload) => {
  state.logSources = payload;
};

const setGrokPatterns = (state, payload) => {
  state.grokPatterns = payload;
};

const setProducts = (state, payload) => {
  state.products = payload;
};

const setTokenResetTimestamp = (state, payload) => {
  state.tokenResetTimestamp = payload;
};

const setMenuCollapsed = (state, payload) => {
  state.menuCollapsed = payload;
};

const setListCollapsed = (state, payload) => {
  state.listCollapsed = payload;
};

export default {
  setAuthentication,
  setDecodedAuthentication,
  setUserRole,
  setOrganisations,
  setSelectedOrganisation,
  setLogSources,
  setGrokPatterns,
  setProducts,
  setTokenResetTimestamp,
  setMenuCollapsed,
  setListCollapsed,
};
